import http from "@core/fetch";

export function useSetDefaultWorkspace() {
    function setDefaultWorkspace(workspaceId: number): Promise<void> {
        return http.post("set default workspace", { workspaceId }, {}, "none");
    }

    return { setDefaultWorkspace };
}
